import React, { useCallback, useEffect, useState } from "react";
import { IAgentWorkflow } from "../../../../../../../models/AgentRuntime.model";
import { IEdge } from "../../../../../../shared/widgets/ReactFlow/models/edge.model";
import { INode } from "../../../../../../shared/widgets/ReactFlow/models/node.model";
import SharedFlow from "../../../../../../shared/widgets/ReactFlow/ReactFlow";

interface AgentRunProps {
  workflows: IAgentWorkflow[];
  activeIndex: number;
}

export default function FlowConfig({ workflows, activeIndex }: AgentRunProps) {
  const [renderedWorkflows, setRenderedWorkflows] = useState({
    nodes: [],
    edges: [],
  });
  const returnNodes = useCallback(
    (tabs: IAgentWorkflow[]) => {
      const createNodes: INode[] = [
        {
          id: "1",
          data: { label: "__start__" },
          position: { x: 260, y: 0 },
          className: "start success",
        },
      ];
      tabs.forEach((item, i) => {
        const index = i + 2;
        createNodes.push({
          id: index.toString(),
          data: { label: item.tabName },
          position: { x: 260, y: 50 + i * 50 },
          className: `${tabs.length - 1 === activeIndex ? "success" : i === activeIndex ? "running" : i < activeIndex && "success"}`,
        });
      });
      createNodes.push({
        id: (tabs.length + 2).toString(),
        data: { label: "__end__" },
        position: { x: 260, y: 0 + (tabs.length + 1) * 50 },
        className: `end ${tabs.length - 1 === activeIndex ? "success" : ""}`,
      });
      const createEdges: IEdge[] = createNodes.map((item, i) => {
        let isAnimated = false;
        const index = i + 1;
        if (createNodes[index]) {
          isAnimated = createNodes[index].className === "running";
        }
        const source = (i + 1).toString();
        const target = (i + 2).toString();
        return {
          id: `e${source}-${target}`,
          source,
          target,
          animated: isAnimated,
        };
      });
      return {
        nodes: createNodes,
        edges: createEdges,
      };
    },
    [activeIndex],
  );

  useEffect(() => {
    const work: any = returnNodes(workflows);
    setRenderedWorkflows(work);
  }, [returnNodes, workflows]);

  return <SharedFlow nodeProps={renderedWorkflows} maxZoom={2} />;
}
